(function () {
  'use strict'

  const MODULE_NAME = 'thismoment.embed.provider.embed-api'

  require('angular')
    .module(MODULE_NAME, [
      require('../../api/async')
    ])
    .provider('EmbedApi', embedApiProvider)

  function embedApiProvider () {
    return {
      $get: embedApiService
    }
  }

  embedApiService.$inject = ['SdkConfig', 'ThismomentAsyncApi']
  function embedApiService (SdkConfig, ThismomentAsyncApi) {
    var API = ThismomentAsyncApi.configureResource(SdkConfig.get('content_cloud_url') + '/api/solution/v1/get-embed-config')

    return {
      getConfig: getConfig
    }

    function getConfig (embedId, accountId, groupId) {
      return API.post(null, {
        id: embedId,
        a: accountId,
        g: groupId
      })
    }
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/embed/provider/embed-api.js